const Strings = {
  BOOK_LAUNDRY: {
    SE: 'Boka tvättid',
    EN: 'Book laundry time'
  },
  OTHER_BOOKING_SYSTEM: {
    SE: 'Andra bokningssystem',
    EN: 'Other booking systems'
  },
  MY_BOOKINGS: {
    SE: 'Mina bokningar',
    EN: 'My bookings'
  },
  MY_LAUNDRY_BOOKINGS: {
    SE: 'Mina tvättbokningar',
    EN: 'My laundry bookings'
  },
  REPORT_AN_ERROR: {
    SE: 'Rapportera ett fel',
    EN: 'Report an error'
  },
  SEE_MY_ERROR_REPORTS: {
    SE: 'Felrapporteringar',
    EN: 'Error reports'
  },
  SIGN_OUT: {
    SE: 'Logga ut',
    EN: 'Sign out'
  },
  MY_SETTINGS: {
    SE: 'Mina inställningar',
    EN: 'My settings'
  },
  INFORMATION_SETTINGS: {
    SE: 'Infotavlan',
    EN: 'Info board'
  },
  TO_ASSOCIATION_SETTINGS: {
    SE: 'Föreningsinställningar',
    EN: 'Association settings'
  },
  NEWS: {
    SE: 'Nyheter',
    EN: 'News'
  },
  MY_PAGE: {
    SE: 'Min sida',
    EN: 'My page'
  },
  BOOKING_SYSTEMS: {
    SE: 'Bokningssystem',
    EN: 'Booking systems'
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/common/listItems/strings.js